import React, { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import Button from 'react-bootstrap/Button';
import './custom.scss';

const VerificationGate = ({ children, forceShow = false }) => {
  const [isVerified, setIsVerified] = useState(true);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (forceShow) {
      setIsVerified(false); // force it to show the modal
      setChecked(true);
      return;
    }
    
    const token = localStorage.getItem('authToken');
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setIsVerified(decoded?.is_verified !== false);
      } catch (e) {
        console.error('Invalid token:', e);
      }
    }
    setChecked(true);
  }, [forceShow]);

  const handleLogout = () => {
    localStorage.removeItem('authToken');
    localStorage.setItem('logout-event', Date.now());
    window.location.href = '/';
  };

  if (!checked) return null;

  return (
    <>
      {children}
      {!isVerified && (
        <div className="blocking-overlay">
          <div className="blocking-modal">
            <h6 className="text-info-emphasis blocking-text">
              Ο λογαριασμός σου δεν έχει επαληθευτεί.
            </h6>
            <Button variant="outline-danger" onClick={handleLogout}>
              Αποσύνδεση
            </Button>
          </div>
        </div>
      )}
    </>
  );
};


export default VerificationGate;
